module.exports = __webpack_public_path__ + "b1f87bccdee2f9f0f5bbcea3f1c5d055.jpg";